@defer(when eventSystems$ | async){
    <h1>Our Event Systems</h1>
    @for (eventSystem of eventSystems$ | async; track $index){
        <app-event-system-headline [system]="eventSystem"/>
    }
}
@placeholder {
    <app-loading />
}
